import { Block, BlockField, BlockRow } from "./Block"
import { Overlay } from "./Overlay"
import type { LanguageTextReplacementFunction } from "../App/Localization"

interface OpenServerDialogProps {
  pending: boolean;
  onClose: () => void;
  onRetry: () => void;
  t: LanguageTextReplacementFunction;
}

export function OpenServerDialog({ pending, onClose, onRetry, t }: OpenServerDialogProps) {
  return (
    <Overlay className="OpenServerDialog" containerClassName="OpenServerDialog-layer"
      style={pending ? undefined : "alarm"} title={t("title")} hideClose={pending}
      closeCallback={pending ? undefined : onClose} closeBackground={!pending}
    >
      <div className="Overlay-body">
        <Block>
          <BlockRow>
            {pending ? <div role="status">{t("opening")}</div> : <div role="alert">{t("failed")}</div>}
          </BlockRow>
          {!pending && (
            <BlockRow actions={true}>
              <BlockField><button className="button" onClick={onClose}>{t("close")}</button></BlockField>
              <BlockField><button className="button default" onClick={onRetry}>{t("retry")}</button></BlockField>
            </BlockRow>
          )}
        </Block>
      </div>
    </Overlay>
  );
}
